import Colors from "../../../assets/Variables/ColorsVariables";

export const FONT_FAMILY = '"Plus Jakarta Sans", sans-serif';

export const dialogSx = {
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(15,23,42,0.45)",
    backdropFilter: "blur(4px)",
  },
  "& .MuiDialog-container": {
    alignItems: "flex-start",
  },
};

export const dialogPaperSx = {
  width: "549px",
  maxWidth: "549px",
  height: "720px",
  maxHeight: "720px",
  mt: "150px",
  borderRadius: "24px",
  p: 3,
  boxShadow: "0 24px 60px rgba(15,23,42,0.35)",
  backgroundColor: "#FFFFFF",
  fontFamily: FONT_FAMILY,
};

export const headerTitleSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 600,
  fontSize: 22,
  lineHeight: "100%",
  letterSpacing: "0.15px",
  color: "#15202A",
};

export const visibilityLabelSx = {
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  color: "#64748B",
};

export const closeButtonSx = {
  minWidth: "auto",
  p: 0,
  color: "#94A3B8",
  fontSize: 20,
  lineHeight: 1,
  "&:hover": { backgroundColor: "transparent", color: "#0F172A" },
};

export const messageSx = {
  mb: 2,
  fontFamily: FONT_FAMILY,
  fontSize: 13,
  color: "#64748B",
};

export const drawdownLabelSx = {
  fontFamily: "Plus Jakarta Sans, sans-serif",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: 1.4,
  color: Colors.Secondary_700,
  marginBottom: "4px",
};

export const toggleGroupSx = {
  display: "flex",
  gap: 1.5,
  "& .MuiToggleButton-root": {
    flex: 1,
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: "#0F172A",
    backgroundColor: "#FFFFFF",
    "&.Mui-selected": {
      backgroundColor: "#0F172A",
      color: "#FFFFFF",
      borderColor: "#0F172A",
    },
    "&:hover": {
      backgroundColor: "#F8FAFC",
    },
  },
};

export const actionsSx = {
  p: 3,
  pt: 2,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const cancelButtonSx = {
  minWidth: 80,
  height: 48,
  px: 2,
  py: 1.5,
  borderRadius: "10px",
  borderWidth: "1px",
  borderColor: "#15202A",
  color: "#15202A",
  backgroundColor: "#FFFFFF",
  textTransform: "none",
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  "&:hover": {
    backgroundColor: "#F9FAFB",
    borderColor: "#15202A",
  },
};

export const continueButtonProps = {
  color: "#FFFFFF",
  backgroundColor: Colors.Error_500 || "#EB0000",
  width: "120px",
  padding: "18px 16px",
};

export const statementDialogPaperSx = {
  width: 500,
  height: 640,
  padding: "32px 24px 32px 24px",
  boxSizing: "border-box",
  overflow: "hidden",
  borderRadius: "20px",
  backgroundColor: "#FFFFFF",
};

export const statementDialogSx = {
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    background: "#FFFFFF",
  },
};

export const statementHeaderTitleSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 600,
  fontSize: "22px",
  lineHeight: "100%",
  letterSpacing: "-0.15px",
  color: Colors.Secondary_900,
  width: "459px",
  height: "16px",
};

export const statementCloseButtonSx = {
  minWidth: "32px",
  height: "32px",
  borderRadius: "999px",
  fontSize: "40px",
  lineHeight: 1,
  padding: 0,
  color: Colors.Secondary_500,
  "&:hover": { backgroundColor: Colors.Gray_100 },
};

export const statementCardBoxSx = {
  display: "grid",
  gridTemplateColumns: "1fr 0.8fr",
  width: "450px",
  height: "115px",
  padding: "16px 16px 16px 16px",
  borderRadius: "16px",
  backgroundColor: Colors.Secondary_50,
  mt: 1.5,
  columnGap: "23px",
};

export const statementLabelMutedSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "140%",
  color: Colors.Secondary_900,
  mb: 0.5,
};

export const statementValueSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "140%",
  color: Colors.Secondary_700,
};

export const statementStatusLabelSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "140%",
  color: Colors.Secondary_900,
  mb: 0.5,
};

export const statementSectionTitleSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  color: Colors.Secondary_900,
  mt: 2,
  mb: 1.5,
};

export const statementDetailsGridSx = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "32px",
  rowGap: "16px",
};

export const statementReasonTitleSx = {
  fontFamily: FONT_FAMILY,
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "140%",
  color: Colors.Secondary_900,
  mb: 0.5,
};